import { defineComponent as _defineComponent } from 'vue'

import TeamMembers from "@/modules/Missions/components/Details/TeamMembers/TeamMembers.vue"
import ManageTeamRoles from "@/modules/Missions/components/Details/ManageTeamRoles/ManageTeamRoles.vue"
import { MissionLifecycleFragmentFragment } from "@/gql"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamTab',
  props: {
    mission: null
  },
  setup(__props: any) {



const { refetchQueries } = useMissionLifecycleContext()

return { __sfc: true,refetchQueries, TeamMembers, ManageTeamRoles }
}

})